import type { ClassValue } from 'clsx'
import { clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        { text: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] },
        { text: ['heading-xl', 'heading-lg', 'heading-md', 'heading-sm', 'heading-xs'] },
        { text: ['title-xl', 'title-lg', 'title-md', 'title-sm'] },
        { text: ['paragraph-xl', 'paragraph-lg', 'paragraph-md', 'paragraph-sm', 'paragraph-xs'] },
        { text: ['subheading-lg', 'subheading-md', 'subheading-sm', 'subheading-xs', 'subheading-2xs'] },
        { text: ['label-xl', 'label-lg', 'label-md', 'label-sm', 'label-xs'] },
        { text: ['docs-heading', 'docs-subheading', 'docs-label', 'docs-paragraph'] },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
